import React from 'react';
import { useIntl } from 'react-intl';

const About = () => {
  const intl = useIntl();
  const isEnglish = intl.locale === 'en';

  const renderContent = (id: string, fallback: string) => {
    return isEnglish ? fallback : intl.formatMessage({ id });
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-indigo-800 mb-6">
        {renderContent('about.title', 'About Pokedle')}
      </h1>
      <p className="text-lg mb-4">
        {renderContent('about.description1', 'Pokedle is a daily Pokémon guessing game inspired by the popular word game Wordle. Each day, players are presented with a silhouette of a Pokémon and must guess its identity within six attempts.')}
      </p>
      <p className="text-lg mb-4">
        {renderContent('about.description2', 'Our goal is to provide a fun and challenging way for Pokémon fans to test their knowledge and compete with friends. Whether you\'re a seasoned Pokémon Master or just starting your journey, Pokedle offers a daily dose of Pokémon fun!')}
      </p>
      <p className="text-lg">
        {renderContent('about.description3', 'Pokedle is created by fans, for fans, and is not affiliated with or endorsed by The Pokémon Company, Nintendo, or Game Freak.')}
      </p>
    </div>
  );
};

export default About;